import idx from 'idx';
import { fetchPricing } from 'pap/ducks/pricing';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { fetchCategoriesIfNeeded, getSubCategory } from 'common/ducks/categories';
import Packages from 'marketing/components/pricing_packages';

export function mapStateToProps(state, { category }) {
  const packages = idx(state, _ => _.pap.pricing.packages) || [];
  return {
    packages,
    category,
    subCategory: getSubCategory(state.categories, category),
    centeredIntro: true
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchPricing,
    fetchCategoriesIfNeeded,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Packages));



// WEBPACK FOOTER //
// ./landing_pages/containers/pricing.js